import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NeveMeasurementsTableComponent } from './neve-measurements-table.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedProviderModule } from '~app/shared/shared.module';
import { QmDirectivesModule } from '~app/components/qm-directives/qm-directives.module';

@NgModule({
  declarations: [NeveMeasurementsTableComponent],
  imports: [ CommonModule, SharedProviderModule, TranslateModule, NgbNavModule, QmDirectivesModule ],
  exports: [NeveMeasurementsTableComponent],
  providers: [],
})
export class NeveMeasurementsModule {}
